let isTravelPassEnabled: boolean | undefined;

const checkIsTravelPassEnabled = () => {
  if (isTravelPassEnabled !== undefined) {
      return isTravelPassEnabled;
  }

  try {
    isTravelPassEnabled = window.dazn.features.isEnabledAnonymous(
          'nfl_travel_pass_theme_enabled'
      );

      return isTravelPassEnabled;
  } catch (_err) {
      return false;
  }
};

export { checkIsTravelPassEnabled }